import { useState,useEffect } from 'react';
import BusinessExpense from './BusinessExpense';
import PersonalExpense from './PersonalExpense';
import CattleFeed from './CattleFeed';
import axios from "axios";
import Cookies from "js-cookie";
import { url } from '../../../../../../../../../App';
import {useParams } from "react-router-dom";
import { useBorrowerContext } from '../../../../../../store/borrower-details';

const ExpenseTable = () => {
    const { loanid } = useParams();
    const loanId = loanid;
    const [visible, setvisible] = useState(false);
    const [addExpense, setAddExpense] = useState(false);
    const [editExpense, setEditExpense] = useState(false);
    const [deleteExpense, setDeleteExpense] = useState(false);
    const token = Cookies.get("Token");
    const email = Cookies.get("Email");
    const { borrowerData } = useBorrowerContext();
    const fetchLoanDetails = borrowerData.loan;
    const foundLoan = fetchLoanDetails.find((item) => item.loan_id === loanId);
    const [isDisbursed, setIsDisbursed] = useState(false);

  useEffect(() => {
    if (loanId) {
      setIsDisbursed(foundLoan?.loan_status === "DISBURSED");
    }
    //eslint-disable-next-line
  }, [foundLoan]);

    useEffect(() => {
        if (email === "rupesh.bishnoi@credin.in") {
            setvisible(true);
        } else {
            axios
                .post(url + "/user/getsingle", {
                    token: token,
                    email: email,
                    useremail: email
                })
                .then((res) => {
                    setAddExpense(res.data[0]?.permission.add_expenses_cam)
                    setEditExpense(res.data[0]?.permission.edit_expenses_cam)
                    setDeleteExpense(res.data[0]?.permission.delete_expenses_cam)
                })
                .catch((err) => {
                    console.log(err);
                })
        };

    }, [email, token]);

    return (
        <div>
            <hr className="hori-line" />
            <div className="expense-form">
                <BusinessExpense loanId={loanId} visible={visible} addExpense={addExpense} editExpense={editExpense} deleteExpense={deleteExpense} isDisbursed={isDisbursed} />
                <PersonalExpense loanId={loanId} visible={visible} addExpense={addExpense} editExpense={editExpense} deleteExpense={deleteExpense} isDisbursed={isDisbursed} />
                <CattleFeed loanId={loanId} visible={visible} addExpense={addExpense} editExpense={editExpense} deleteExpense={deleteExpense} isDisbursed={isDisbursed} />
            </div>
        </div>
    );
};

export default ExpenseTable;

